import React, { FC } from "react";
import { Button, Link, Stack, Typography } from "@mui/material";

import { addParameters, bookADemoURL } from "@src/urls";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";
import { KeyboardArrowRightRounded } from "@mui/icons-material";
import { UtmParameters } from "@src/helpers/utms";

interface Props {
  label?: string;
  color?: "secondary" | "primary";
  variant?: "outlined" | "contained" | "text";
  ctaUtms?: UtmParameters;
}

const BookADemoButton: FC<Props> = ({
  label = "Book A Demo",
  color = "primary",
  variant = "contained",
  ctaUtms = {},
}) => {
  const url = addParameters(bookADemoURL, ctaUtms);

  return (
    <Link href={url} underline="none">
      <Button
        variant={variant}
        color={color}
        disableRipple
        disableElevation
        fullWidth
        sx={{ height: "50px", borderRadius: "8px" }}
      >
        <Stack direction="row" gap={1} alignItems="center">
          <Typography
            variant="body2"
            sx={{
              color: Colors.PrimaryContrast,
              fontSize: "16px",
              lineHeight: "32px",
              fontWeight: "400",
            }}
          >
            {label}
          </Typography>

          <KeyboardArrowRightRounded
            sx={{ marginLeft: "4px", fontSize: "20px" }}
          />
        </Stack>
      </Button>
    </Link>
  );
};

export default BookADemoButton;
